module.exports = __webpack_public_path__ + "static/media/paragraphe5.02824b0d.jpg";